import { FC, memo, useMemo } from 'react';
import { Avatar } from 'shared/components/Avatar';
import { useBreakpoint } from 'shared/hooks/useBreakpoint';
import { useJobPositions } from 'shared/hooks/useJobPositions';

interface UserBadgeProps {
  firstName: string;
  lastName: string;
  jobPositionId: string;
}

export const UserBadge: FC<UserBadgeProps> = memo(({ firstName, lastName, jobPositionId }) => {
  const { getJobPositionById } = useJobPositions();
  const isMobile = useBreakpoint('lg');

  const jobPosition = useMemo(() => getJobPositionById(jobPositionId), [jobPositionId]);

  if (!isMobile) {
    return <Avatar size={40} />;
  }

  return (
    <div className="flex flex-row gap-3 pr-8 lg:flex-col lg:items-center lg:justify-center lg:gap-2 lg:px-4 lg:text-center">
      <Avatar />
      <div className="flex flex-col items-start lg:items-center">
        <p className="text-base font-bold text-white lg:text-black">
          {firstName} {lastName}
        </p>
        <p className="font-medium text-gray-400 lg:text-gray">
          {jobPosition?.name ?? jobPositionId}
        </p>
      </div>
    </div>
  );
});
